<template>
  <v-container fluid class="e-min-height  primary-gradiente" style="padding-top: 65px;">
    <Diccionario :id_unit="this.idUnidad" :isPractice="true"/>
    <v-layout row wrap class="fill-height" style="min-height: calc(100vh - 96px);">
      <v-flex xs12>
        <v-layout column>
          <HeaderFill title="Práctica Avanzado" :router="`/unidad/detalle/${idUnidad}`" />
          <CardSeparador color="rosa" 
            :router="`/practica/avanzada/${idUnidad}/ejercicio`" 
            descripcion="Responda correctamente después de leer el siguiente texto." 
            :image="require('@/assets/images/practica/practica-avanzada.png')"/>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import CardSeparador from '../../../components/Practica/Global/CardSeparador'
export default {
  name: 'PracticaSeparadorAvanzado',
  props: ['idUnidad'],
  components: {
    CardSeparador
  }
}
</script>
